import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { colorOptions } from '../../../constants/constants';
import colorCodeEnum from '../../../constants/enums/color-code-enum';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import PrintContentForm from '../forms/print-content-form';
import { values } from 'lodash';

interface IProps extends IFormModalProps {
  printContents: string[];
  // copies: number;
  templateName: string;
}

const PrintContent = (props: IProps) => {
  const { trayManagementStore, dashboardStore } = useStore();
  const { duplicateData } = trayManagementStore;

  const {
    LEDFormInitialValue,
    TimerOptions,
    ledBlinkState,
    LedBlinkService,
    resetLedBlinkState,
  } = dashboardStore;
  // const initialValues: any = LEDFormInitialValue;
  const initialValues = { Copies: 0 };

  useEffect(() => {
    if (ledBlinkState.success) {
      toast.success(formatMessage('added_success'));
      onModalClosed();
    }
  }, [ledBlinkState.success]);

  useEffect(() => {
    if (ledBlinkState.error) {
      toast.error(formatMessage(ledBlinkState.error));
      resetLedBlinkState();
    }
  }, [ledBlinkState.error]);

  const onSubmitForm = (data: any) => {
    onModalClosed();
  };

  const onModalClosed = () => {
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className="correction-modal fancy-modal print-copies"
        addHeader="copies_title"
        updateHeader="copies_title"
        onModalClosed={onModalClosed}
        isLoading={ledBlinkState.inProgress}
      >
        <PrintContentForm
          initialValues={initialValues}
          id={props.id}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={ledBlinkState.inProgress}
          printContents={props.printContents}
          // copies={props.copies}
          templateName={props.templateName} // duplicateData={duplicateData}
          // timerOptions={TimerOptions}
          // colorOptions={colorOptions}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(PrintContent);
